import { openConfirmModal, useShowNotification } from '@inflearn/ds-react-next';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';

import useNoteIdDeleteMutation from '../../../../mutations/useNoteIdDeleteMutation';
import { getUseNoteIdWithUnitsQueryKey } from './queries/useNoteIdWithUnitsQuery';

export function useDeleteNote(noteId: string, courseNoteId: string) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { mutate: deleteMutate, isLoading: isDeleting } = useNoteIdDeleteMutation(noteId, {
    onSuccess: () => {
      void queryClient.invalidateQueries(getUseNoteIdWithUnitsQueryKey(courseNoteId));
    },
    onError: () => {
      showNotification({
        type: 'error',
        title: t('노트 삭제 실패'),
        message: t('잠시 후 다시 시도해 주세요.'),
      });
    },
  });
  const { showNotification } = useShowNotification();

  const handleConfirmDelete = () => {
    deleteMutate({});
  };

  const handleClickDelete = () => {
    openConfirmModal({
      size: 'xs',
      footerType: 'right',
      withCloseButton: true,
      title: t('노트 삭제'),
      children: (
        <>
          {t('노트를 삭제하시겠어요?')}
          <br />
          {t('삭제한 내용은 복구되지 않습니다.')}
        </>
      ),
      labels: {
        cancel: t('취소'),
        confirm: t('삭제'),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: handleConfirmDelete,
    });
  };

  return { handleClickDelete, isDeleting };
}

export default useDeleteNote;
